/**
 * CRO PDP JavaScript — Livera Shield (90-dag subtiel variant)
 * Template: cro-test-firmhouse-90-subtiel
 * Product: livera-shield-copy (ID 10854697238874)
 * Extra: 90-dag subscription card met selling plan 692174750042
 * Functionaliteit:
 *  1. Variant switching met per-dag prijs update
 *  2. Sticky ATC balk (verschijnt na scrollen voorbij hero)
 *  3. Afbeelding switcher
 *  4. Savings berekening
 *  5. 90-dag subscription card + submit interceptor
 */

document.addEventListener('DOMContentLoaded', function () {
(function () {
  'use strict';

  // Per-dag prijzen en vergelijkingsprijzen per variant index (3 eenmalige kaarten)
  const variantData = {
    0: { perDay: '€0,67', days: 60,  compare: 79.98  },  // 1+1 Gratis
    1: { perDay: '€0,61', days: 90,  compare: 109.98 },  // 1.5+1.5 Gratis
    2: { perDay: '€0,58', days: 120, compare: 139.98 },  // 2+2 Gratis
  };

  // ─── VARIANT SWITCHING ───────────────────────────────────────────
  window.croSelectVariant = function (radioInput) {
    const card = radioInput.closest('.cro-variant-card');
    const variantId = card.dataset.variantId;
    const price = card.dataset.price;
    const perDay = card.dataset.perDay;
    const compare = card.dataset.compare;

    // Deselect all cards
    document.querySelectorAll('.cro-variant-card').forEach(c => {
      c.classList.remove('cro-variant-card--selected');
    });
    card.classList.add('cro-variant-card--selected');

    // Update hidden form input
    const variantInput = document.getElementById('cro-variant-id');
    if (variantInput) variantInput.value = variantId;

    // Update price display
    const priceEl = document.getElementById('cro-price-current');
    const compareEl = document.getElementById('cro-price-compare');
    const perDayEl = document.getElementById('cro-per-day');
    const savingsEl = document.getElementById('cro-savings-amount');

    if (priceEl) priceEl.textContent = price;
    if (compareEl) compareEl.textContent = compare;
    if (perDayEl) perDayEl.textContent = perDay;

    // Calculate savings
    if (savingsEl) {
      const priceNum = parseFloat(price.replace('€', '').replace(',', '.'));
      const compareNum = parseFloat(compare.replace('€', '').replace(',', '.'));
      const savings = (compareNum - priceNum).toFixed(2).replace('.', ',');
      savingsEl.textContent = '€' + savings;
    }

    // Update sticky bar: variant naam + per-dag prijs
    const stickyVariant = document.getElementById('cro-sticky-variant');
    const stickyPerDay = document.getElementById('cro-sticky-per-day');
    const variantTitle = card.dataset.variantTitle || '';
    if (stickyVariant) stickyVariant.textContent = variantTitle;
    if (stickyPerDay) stickyPerDay.textContent = perDay;

    // Update ATC button availability
    const atcBtn = document.getElementById('cro-atc-btn');
    const available = card.dataset.available === 'true';
    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.innerHTML = available
        ? `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Voeg toe aan winkelwagen`
        : 'Uitverkocht';
    }
  };

  // ─── STICKY ATC BAR ──────────────────────────────────────────────
  const stickyBar = document.getElementById('cro-sticky-bar');
  const atcBtn = document.getElementById('cro-atc-btn');

  if (stickyBar && atcBtn) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('cro-sticky-bar--visible');
        } else {
          stickyBar.classList.remove('cro-sticky-bar--visible');
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(atcBtn);
  }

  // ─── STICKY ATC CLICK ────────────────────────────────────────────
  window.croStickyATC = function () {
    // Sync variant ID from main form to sticky
    const variantId = document.getElementById('cro-variant-id')?.value;
    if (!variantId) return;

    // Submit the main product form
    const form = document.querySelector('.cro-product-form');
    if (form) {
      form.querySelector('[name="id"]').value = variantId;
      form.submit();
    }
  };

  // ─── IMAGE SWITCHER met overlay toggle ─────────────────────────
  window.croSwitchImage = function (thumbBtn) {
    const newSrc = thumbBtn.dataset.src;
    const showOverlay = thumbBtn.dataset.overlay === 'true';
    const mainImg = document.getElementById('cro-main-image');
    const overlay = document.getElementById('cro-img-overlay');
    if (mainImg) {
      mainImg.src = newSrc;
      mainImg.style.opacity = '0';
      setTimeout(() => { mainImg.style.opacity = '1'; }, 50);
    }
    // Toon overlay alleen op lifestyle afbeelding
    if (overlay) {
      overlay.style.display = showOverlay ? 'flex' : 'none';
    }
    document.querySelectorAll('.cro-thumb').forEach(t => t.classList.remove('cro-thumb--active'));
    thumbBtn.classList.add('cro-thumb--active');
  };

  // ─── SMOOTH TRANSITION FOR MAIN IMAGE ───────────────────────────
  const mainImg = document.getElementById('cro-main-image');
  if (mainImg) {
    mainImg.style.transition = 'opacity 0.2s ease';
  }

  // ─── VIEWER COUNT ANIMATIE (fluctueert realistisch) ──────────────
  const viewerEl = document.getElementById('cro-viewer-count');
  if (viewerEl) {
    let count = parseInt(viewerEl.textContent) || 23;
    setInterval(() => {
      const delta = Math.random() < 0.5 ? 1 : -1;
      count = Math.max(18, Math.min(31, count + delta));
      viewerEl.textContent = count;
    }, 7000);
  }

  // ─── STOCK COUNT ANIMATIE (daalt langzaam) ───────────────────────
  const stockEl = document.getElementById('cro-stock-count');
  if (stockEl) {
    let stock = parseInt(stockEl.textContent) || 14;
    // Daalt met 1 elke 3-5 minuten, stopt bij 7
    const stockInterval = setInterval(() => {
      if (stock > 7) {
        stock -= 1;
        stockEl.textContent = stock;
      } else {
        clearInterval(stockInterval);
      }
    }, Math.floor(Math.random() * 120000) + 180000); // 3-5 min
  }

  // ─── FAQ SMOOTH OPEN ─────────────────────────────────────────────
  document.querySelectorAll('.cro-faq-item').forEach(item => {
    item.addEventListener('toggle', () => {
      // Close other items when one opens
      if (item.open) {
        document.querySelectorAll('.cro-faq-item').forEach(other => {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  // ─── MID-PAGE CTA VARIANT SELECT ─────────────────────────────────
  window.croMidCtaSelect = function (btn) {
    // Deselect all mid-CTA variants
    document.querySelectorAll('.cro-midcta-variant').forEach(b => b.classList.remove('cro-midcta-variant--selected'));
    btn.classList.add('cro-midcta-variant--selected');

    // Sync selectie naar hoofd buy box
    const variantId = btn.dataset.variantId;
    const price = btn.dataset.price;
    const perDay = btn.dataset.perDay;
    const compare = btn.dataset.compare;
    const variantTitle = btn.dataset.variantTitle;
    const vi = parseInt(btn.dataset.vi);

    // Update hoofd variant radio
    const mainCards = document.querySelectorAll('.cro-variant-card');
    mainCards.forEach(card => card.classList.remove('cro-variant-card--selected'));
    const matchingCard = document.querySelector(`.cro-variant-card[data-variant-id="${variantId}"]`);
    if (matchingCard) {
      matchingCard.classList.add('cro-variant-card--selected');
      const radio = matchingCard.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    }

    // Update hidden form input
    const variantInput = document.getElementById('cro-variant-id');
    if (variantInput) variantInput.value = variantId;

    // Update prijs display
    const priceEl = document.getElementById('cro-price-current');
    const compareEl = document.getElementById('cro-price-compare');
    const perDayEl = document.getElementById('cro-per-day');
    const savingsEl = document.getElementById('cro-savings-amount');
    if (priceEl) priceEl.textContent = price;
    if (compareEl) compareEl.textContent = compare;
    if (perDayEl) perDayEl.textContent = perDay;
    if (savingsEl) {
      const priceNum = parseFloat(price.replace('€', '').replace(',', '.'));
      const compareNum = parseFloat(compare.replace('€', '').replace(',', '.'));
      const savings = (compareNum - priceNum).toFixed(2).replace('.', ',');
      savingsEl.textContent = '€' + savings;
    }

    // Update sticky bar
    const stickyVariant = document.getElementById('cro-sticky-variant');
    const stickyPerDay = document.getElementById('cro-sticky-per-day');
    if (stickyVariant) stickyVariant.textContent = variantTitle;
    if (stickyPerDay) stickyPerDay.textContent = perDay;

    // Update mid-CTA selected info
    const selTitle = document.getElementById('cro-midcta-selected-title');
    const selPrice = document.getElementById('cro-midcta-selected-price');
    const selPerDay = document.getElementById('cro-midcta-selected-perday');
    if (selTitle) selTitle.textContent = variantTitle;
    if (selPrice) selPrice.textContent = price;
    if (selPerDay) selPerDay.textContent = perDay;
  };

  // ─── MID-PAGE CTA ATC ────────────────────────────────────────────
  window.croMidCtaATC = function () {
    const variantId = document.getElementById('cro-variant-id')?.value;
    if (!variantId) return;
    const form = document.querySelector('.cro-product-form');
    if (form) {
      form.querySelector('[name="id"]').value = variantId;
      form.submit();
    }
  };

  // ─── 90-DAGEN ABONNEMENT SELECTIE ──────────────────────────────
  // Selling plan 692174750042 = "Levering elke 90 dagen" voor livera-shield-copy
  // Variant 54170571931994 = "1.5 + 1.5 Gratis"
  // Store pendingSellingPlanId on the ATC button as a data attribute for reliable access
  function setPendingSellingPlan(planId) {
    const btn = document.getElementById('cro-atc-btn');
    if (btn) btn.dataset.pendingSellingPlan = planId || '';
    // Also store on a hidden input for sticky ATC
    let inp = document.getElementById('cro-pending-selling-plan');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.id = 'cro-pending-selling-plan';
      document.body.appendChild(inp);
    }
    inp.value = planId || '';
  }

  function getPendingSellingPlan() {
    const inp = document.getElementById('cro-pending-selling-plan');
    return inp ? inp.value : '';
  }

  let pendingSellingPlanId = null;

  function setSellingPlan(planId) {
    setPendingSellingPlan(planId);
    pendingSellingPlanId = planId;
  }

  window.croSelectSubscription90 = function () {
    const card = document.getElementById('cro-subscription-90-card');
    const variantId = '54170571931994';
    const sellingPlanId = '692174750042';
    const price = '€43,98';
    const compare = '€54,98';
    const perDay = '€0,49/dag';
    const variantTitle = 'Levering elke 90 dagen';

    document.querySelectorAll('.cro-variant-card').forEach(c => c.classList.remove('cro-variant-card--selected'));
    if (card) card.classList.add('cro-variant-card--selected');

    const variantInput = document.getElementById('cro-variant-id');
    if (variantInput) variantInput.value = variantId;

    pendingSellingPlanId = sellingPlanId;
    setSellingPlan(sellingPlanId);

    const priceEl = document.getElementById('cro-price-current');
    const compareEl = document.getElementById('cro-price-compare');
    const perDayEl = document.getElementById('cro-per-day');
    const savingsEl = document.getElementById('cro-savings-amount');
    if (priceEl) priceEl.textContent = price;
    if (compareEl) compareEl.textContent = compare;
    if (perDayEl) perDayEl.textContent = perDay;
    if (savingsEl) {
      const priceNum = parseFloat(price.replace('€', '').replace(',', '.'));
      const compareNum = parseFloat(compare.replace('€', '').replace(',', '.'));
      savingsEl.textContent = '€' + (compareNum - priceNum).toFixed(2).replace('.', ',');
    }

    const stickyVariant = document.getElementById('cro-sticky-variant');
    const stickyPerDay = document.getElementById('cro-sticky-per-day');
    if (stickyVariant) stickyVariant.textContent = variantTitle;
    if (stickyPerDay) stickyPerDay.textContent = perDay;

    const atcBtnEl = document.getElementById('cro-atc-btn');
    if (atcBtnEl) {
      atcBtnEl.disabled = false;
      atcBtnEl.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Voeg toe aan winkelwagen`;
    }
  };

  // Wrap croSelectVariant to clear selling plan when a regular variant is selected
  const _origCroSelectVariant = window.croSelectVariant;
  window.croSelectVariant = function (radioInput) {
    pendingSellingPlanId = null;
    setSellingPlan(null);
    _origCroSelectVariant(radioInput);
  };

  // ─── VARIANT CARD CLICK (entire card clickable) ──────────────────
  document.querySelectorAll('.cro-variant-card').forEach(card => {
    card.addEventListener('click', function () {
      const radio = this.querySelector('input[type="radio"]');
      if (card.dataset.isSubscription === 'true') {
        // 90-dag subscription card
        if (radio) radio.checked = true;
        croSelectSubscription90();
      } else if (radio && !radio.checked) {
        radio.checked = true;
        croSelectVariant(radio);
      }
    });
  });

  // ─── UPSELL MODAL ────────────────────────────────────────────────
  // Variant data: index → { title, days, price (cents), perDay, compare }
  // Upsell logica: toon volgende pakket (vi+1) als upsell
  // Bij 3+3 Gratis (vi=3): geen upsell, direct toevoegen

  const upsellVariantData = [
    { vi: 0, title: '1 + 1 Gratis',     days: 60,  perDay: '€0,67' },
    { vi: 1, title: '1.5 + 1.5 Gratis', days: 90,  perDay: '€0,61' },
    { vi: 2, title: '2 + 2 Gratis',     days: 120, perDay: '€0,58' },
  ];

  let pendingVariantId = null; // de variant die de gebruiker origineel wilde
  let upsellVariantId = null;  // de upsell variant (vi+1)

  function getSelectedVi() {
    const selected = document.querySelector('.cro-variant-card--selected');
    return selected ? parseInt(selected.dataset.vi) : 1;
  }

  function getVariantIdByVi(vi) {
    const card = document.querySelector(`.cro-variant-card[data-vi="${vi}"]`);
    return card ? card.dataset.variantId : null;
  }

  function getPriceByVi(vi) {
    const card = document.querySelector(`.cro-variant-card[data-vi="${vi}"]`);
    return card ? card.dataset.price : null;
  }

  function showUpsellModal(currentVi) {
    const nextVi = currentVi + 1;
    const current = upsellVariantData[currentVi];
    const next = upsellVariantData[nextVi];
    if (!current || !next) return false;

    // Bereken prijsverschil
    const currentPriceCents = parseInt(document.querySelector(`.cro-variant-card[data-vi="${currentVi}"]`)?.dataset.priceRaw || '0');
    const nextCard = document.querySelector(`.cro-variant-card[data-vi="${nextVi}"]`);
    const currentPriceStr = document.querySelector(`.cro-variant-card[data-vi="${currentVi}"]`)?.dataset.price || '';
    const nextPriceStr = nextCard?.dataset.price || '';

    const currentNum = parseFloat(currentPriceStr.replace('€', '').replace(',', '.')) || 0;
    const nextNum = parseFloat(nextPriceStr.replace('€', '').replace(',', '.')) || 0;
    const diff = (nextNum - currentNum).toFixed(2).replace('.', ',');
    const extraDays = next.days - current.days;

    upsellVariantId = getVariantIdByVi(nextVi);

    // Vul modal in
    document.getElementById('cro-upsell-extra-days').textContent = extraDays;
    document.getElementById('cro-upsell-extra-days2').textContent = extraDays;
    document.getElementById('cro-upsell-target-days').textContent = next.days;
    document.getElementById('cro-upsell-target-days2').textContent = next.days;
    document.getElementById('cro-upsell-current-days').textContent = current.days;
    document.getElementById('cro-upsell-diff').textContent = '\u20ac' + diff;
    document.getElementById('cro-upsell-variant-label').textContent = next.title + ' | ' + next.days + ' dagen';
    document.getElementById('cro-upsell-accept-days').textContent = next.days;
    document.getElementById('cro-upsell-decline-days').textContent = current.days;

    // Toon modal
    const overlay = document.getElementById('cro-upsell-overlay');
    overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    document.getElementById('cro-upsell-accept').focus();
    return true;
  }

  function closeUpsellModal() {
    const overlay = document.getElementById('cro-upsell-overlay');
    overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function addToCartAndRedirect(variantId, sellingPlanId) {
    const body = { id: variantId, quantity: 1 };
    if (sellingPlanId) body.selling_plan = sellingPlanId;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(r => r.json())
    .then(() => { window.location.href = '/cart'; })
    .catch(() => { window.location.href = '/cart'; });
  }

  // Intercept ATC button click directly (bypass product-form.js AJAX)
  const atcBtnEl = document.getElementById('cro-atc-btn');
  if (atcBtnEl) {
    atcBtnEl.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = document.getElementById('cro-variant-id')?.value;
      if (!variantId) return;

      // Read selling plan from data attribute (most reliable) or closure variable
      const activePlan = this.dataset.pendingSellingPlan || getPendingSellingPlan() || pendingSellingPlanId;
      if (activePlan) {
        // 90-dag subscription: add with selling_plan
        addToCartAndRedirect(variantId, activePlan);
        return;
      }

      const currentVi = getSelectedVi();
      if (currentVi < 3) {
        pendingVariantId = variantId;
        if (!showUpsellModal(currentVi)) {
          addToCartAndRedirect(variantId);
        }
      } else {
        addToCartAndRedirect(variantId);
      }
    });
  }

  // LEGACY: also intercept form submit for sticky ATC and mid-CTA
  const productForm = document.querySelector('.cro-product-form');
  if (productForm) {
    // CAPTURE PHASE: force selling_plan before Firmhouse can reset it
    productForm.addEventListener('submit', function () {
      if (pendingSellingPlanId) {
        const spInput = this.querySelector('input[name="selling_plan"]');
        if (spInput) {
          spInput.value = pendingSellingPlanId;
        } else {
          const inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'selling_plan';
          inp.value = pendingSellingPlanId;
          this.appendChild(inp);
        }
      }
    }, true); // capture phase

    // BUBBLE PHASE: upsell modal (only for regular variants, skip when 90-dag subscription)
    productForm.addEventListener('submit', function (e) {
      if (pendingSellingPlanId) return; // 90-dag subscription: skip upsell, submit directly
      const currentVi = getSelectedVi();
      if (currentVi < 2) {
        e.preventDefault();
        pendingVariantId = document.getElementById('cro-variant-id')?.value;
        showUpsellModal(currentVi);
      }
      // Bij vi=2 (2+2 Gratis = laatste kaart): gewoon doorgaan met submit
    });
  }

  // Upsell accepteren → voeg upsell variant toe
  const acceptBtn = document.getElementById('cro-upsell-accept');
  if (acceptBtn) {
    acceptBtn.addEventListener('click', function () {
      closeUpsellModal();
      if (upsellVariantId) {
        addToCartAndRedirect(upsellVariantId);
      }
    });
  }

  // Upsell afwijzen → voeg originele variant toe
  const declineBtn = document.getElementById('cro-upsell-decline');
  if (declineBtn) {
    declineBtn.addEventListener('click', function () {
      closeUpsellModal();
      if (pendingVariantId) {
        addToCartAndRedirect(pendingVariantId);
      }
    });
  }

  // Mid-CTA ATC ook via fetch
  window.croMidCtaATC = function () {
    const variantId = document.getElementById('cro-variant-id')?.value;
    if (!variantId) return;
    if (pendingSellingPlanId) {
      addToCartAndRedirect(variantId, pendingSellingPlanId);
      return;
    }
    const currentVi = getSelectedVi();
    if (currentVi < 3) {
      pendingVariantId = variantId;
      if (!showUpsellModal(currentVi)) {
        addToCartAndRedirect(variantId);
      }
    } else {
      addToCartAndRedirect(variantId);
    }
  };

  // Sluit modal via X knop
  const closeBtn = document.getElementById('cro-upsell-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeUpsellModal);
  }

  // Sluit modal bij klik buiten modal
  const overlay = document.getElementById('cro-upsell-overlay');
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeUpsellModal();
    });
  }

  // Sluit modal bij Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const overlay = document.getElementById('cro-upsell-overlay');
      if (overlay && !overlay.hasAttribute('hidden')) closeUpsellModal();
    }
  });

  // Sticky ATC ook intercepten voor upsell
  window.croStickyATC = function () {
    const variantId = document.getElementById('cro-variant-id')?.value;
    if (!variantId) return;
    if (pendingSellingPlanId) {
      addToCartAndRedirect(variantId, pendingSellingPlanId);
      return;
    }
    const currentVi = getSelectedVi();
    if (currentVi < 3) {
      pendingVariantId = variantId;
      if (!showUpsellModal(currentVi)) {
        addToCartAndRedirect(variantId);
      }
    } else {
      addToCartAndRedirect(variantId);
    }
  };

  // Mid-page CTA ook intercepten voor upsell
  window.croMidCtaATC = function () {
    const variantId = document.getElementById('cro-variant-id')?.value;
    if (!variantId) return;
    if (pendingSellingPlanId) {
      const form = document.querySelector('.cro-product-form');
      if (form) { form.querySelector('[name="id"]').value = variantId; form.submit(); }
      return;
    }
    const currentVi = getSelectedVi();
    if (currentVi < 2) {
      pendingVariantId = variantId;
      showUpsellModal(currentVi);
    } else {
      addToCartAndRedirect(variantId);
    }
  };

})();
});
